import {Link} from "react-router-dom";
import {Avatar} from "primereact/avatar";
import {generateHSL, getLettereAvatar} from "../../../utility/avatar";
import NsMenuUtenteController from "./NsMenuUtenteController";

export default function NsMenuEnd({
                                      user,
                                      isMobile,
                                      aggiornaLingua,
                                      annoKpi,
                                      anni,
                                      refMenuUsr,
                                      onChangeAnno,
                                  }) {

    return (
        <div className="flex align-items-center gap-2">
            <div className={"ns-logo-end-container"}>
                <Link to="/home-container">
                    <img src={"YEP-logo-negativo.svg"} className={"ns-logo-icon"} alt="YEP Logo"/>
                </Link>
            </div>
            {
                /*Se l'utente non è loggato disegno le icone per la lingua fuori dalla card dell'utente*/
                !user &&
                <span
                    className="pe-2 ns-mouse-pointer"
                    onClick={() => aggiornaLingua('it')}
                >
                    <i className="flag-icon flag-icon-it"/>
                </span>
            }
            {
                !user &&
                /*Se l'utente non è loggato disegno le icone per la lingua fuori dalla card dell'utente*/
                <span
                    className="pe-3 ns-mouse-pointer"
                    onClick={() => aggiornaLingua('en')}
                >
                    <i className="flag-icon flag-icon-gb"/>
                </span>
            }
            {
                user &&
                <div className={"ns-menu-end"}>
                    {
                        !isMobile &&
                        <select
                            className={"form-select-sm me-3"}
                            value={annoKpi}
                            onChange={onChangeAnno}
                        >
                            {
                                anni && anni.map((anno) =>
                                    <option key={anno} value={anno}>{anno}</option>
                                )
                            }
                        </select>
                    }
                    <Avatar
                        //icon={"pi pi-user"}
                        label={getLettereAvatar(user)}
                        shape="circle"
                        style={{
                            color: "#ffffff",
                            backgroundColor: generateHSL(getLettereAvatar(user))
                        }}
                        onClick={(e) => refMenuUsr.current.toggle(e)}
                    />
                    <NsMenuUtenteController
                        anni={anni}
                        refMenuUsr={refMenuUsr}
                    />
                </div>
            }
        </div>
    );
}